import React from 'react';
import PropTypes from 'prop-types';
import PDFObject from 'pdfobject';

import { ATTACHMENTS } from 'newJs/config';
import { FaIcon, IoIcon } from 'components/Icons';
import { useAttachsParams } from 'providers/attachs-params';
import Action from './Action';
import ActionGroup from './Component/ActionGroup';
import { useGlobalProps } from 'providers/global-props';

const { CLICK_ACTIONS } = ATTACHMENTS;
const {
    DOWNLOAD, PLAY, SAVE_TO_CONTACTS, SAVE_TO_FILES, SAVE_TO_FOTO, VIEW_CALENDAR, VIEW_IMAGE, VIEW_PDF, VIEW_ZIP
} = CLICK_ACTIONS;

const ActionPanel = (props) => {
    // console.dir(props);
    const { hasError = false, item, itemData } = props;
    const { MAPI } = useGlobalProps();
    const { browser, isApiEnabled } = useAttachsParams();
    const filesApiEnabled = isApiEnabled('files');
    const fotoApiEnabled  = isApiEnabled('foto');
    const isMsBrowser = ['msie', 'msedge'].includes(browser.name);

    return (
        <ActionGroup>
            {/* NOTE:
                According to Kuznecovs in case of server error (e.g. 500 or 502) component must show only "Download" button.
            */}
            <Action actionName={DOWNLOAD}>
                <IoIcon name='IoMdDownload' />
            </Action>
            {item.isViewable && item.isImage && (
                <Action actionName={VIEW_IMAGE}>
                    <FaIcon name='FaRegEye' />
                    <img
                        alt={itemData.name}
                        className='action-image'
                        loading='lazy'
                        src={`${MAPI.baseUrl}${itemData.href}?inline=true`}
                        // title={itemData.name} [MAIL-5517]
                    />
                </Action>
            )}
            {!hasError && (
                <React.Fragment>
                    {item.isZip && (
                        <Action actionName={VIEW_ZIP}>
                            <FaIcon name='FaRegEye' />
                        </Action>
                    )}
                    {item.isCalendar && !browser.msie && (
                        <Action actionName={VIEW_CALENDAR}>
                            <FaIcon name='FaRegEye' />
                        </Action>
                    )}
                    {!isMsBrowser
                        ? PDFObject.supportsPDFs && item.isPdf && (
                            <Action actionName={VIEW_PDF}>
                                <FaIcon name='FaRegEye' />
                            </Action>
                        ) : ''
                    }
                    {item.isPlayable && (
                        <Action actionName={PLAY}>
                            <FaIcon name='FaPlay' size='0.8em' />
                        </Action>
                    )}
                    {filesApiEnabled && (
                        <Action actionName={SAVE_TO_FILES}>
                            <i className="ico-product prod-files" />
                        </Action>
                    )}
                    {fotoApiEnabled && item.isImage && (
                        <Action actionName={SAVE_TO_FOTO}>
                            <i className="ico-product prod-foto" />
                        </Action>
                    )}
                    {item.isVCard && (
                        <Action actionName={SAVE_TO_CONTACTS}>
                            <i className="ico-product prod-contacts" />
                        </Action>
                    )}
                </React.Fragment>
            )}
        </ActionGroup>
    );
};

ActionPanel.propTypes = {
    hasError: PropTypes.bool,
    item: PropTypes.object,
    itemData: PropTypes.object,
};

export default ActionPanel;
